import type { RequestOptions } from '@@/plugin-request/request';
import type { RequestConfig } from '@umijs/max';
import type { AxiosResponse } from 'axios';
import { BACKEND_HOST_LOCAL, BACKEND_HOST_PROD } from './constants';

// 与后端约定的响应数据格式
interface ResponseStructure {
  success: boolean;
  data: any;
  errorCode?: number;
  errorMessage?: string;
}

const isDev = process.env.NODE_ENV === 'development';

/**
 * @name 错误处理
 * pro 自带的错误处理， 可以在这里做自己的改动
 * @doc https://umijs.org/docs/max/request#配置
 */
export const requestConfig: RequestConfig = {
  baseURL: isDev ? BACKEND_HOST_LOCAL : BACKEND_HOST_PROD,
  withCredentials: true,

  // 请求拦截器
  requestInterceptors: [
    (config: RequestOptions) => {
      const token = sessionStorage.getItem('token');
      if (token) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${token}`,
        };
      }
      return config;
    },
  ],

  // 响应拦截器
  responseInterceptors: [
    (response: AxiosResponse) => {
      // 请求地址
      const requestPath: string = response.config.url ?? '';

      // 检查 HTTP 状态码
      const httpStatus = response.status;

      // HTTP 401 未授权，跳转登录页
      if (
        httpStatus === 401 &&
        !requestPath.includes('user/get/login') &&
        !location.pathname.includes('/user/login')
      ) {
        window.location.href = `/user/login?redirect=${window.location.href}`;
        throw new Error('请先登录');
      }

      // HTTP 状态码非 2xx，抛出错误
      if (httpStatus < 200 || httpStatus >= 300) {
        const { data } = response as unknown as ResponseStructure;
        throw new Error(
          data?.errorMessage || data?.message || `请求失败 (${httpStatus})`,
        );
      }

      // HTTP 状态码正常，直接返回
      return response;
    },
  ],
};
